import {
    SIGNIN,
    SIGNIN_SUCCESS,
    SIGNIN_FAIL,

    CADASTRO,
    CADASTRO_SUCCESS,
    CADASTRO_FAIL,

    LOGIN_SIG,
    LOGIN_SIG_SUCCESS,
    LOGIN_SIG_FAIL,

    CADASTRO_USER,
    LIMPA_MSGS

} from '../actions/types';

const INITIAL_STATE = {
    loading_auth: false,
    error_auth: '',
    token: '',

    login_sig: false,
    error_sig_auth: '',
    msg_cadastroUser: '',
    error_cadastro:false,
    user: JSON.parse(localStorage.getItem('user') || '{}')
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case SIGNIN:
            return {
                ...state,
                loading_auth: true,
                error_auth: ''
            }
        case SIGNIN_SUCCESS:
            return {
                ...state,
                loading_auth: false,
                token: action.payload,
                error_auth: '',
            }
        case SIGNIN_FAIL:
            return {
                ...state,
                loading_auth: false,
                error_auth: action.payload
            }
        case CADASTRO: {
            return {
                ...state,
                loading_auth: true,
                error_auth:''
            }
        }
        case CADASTRO_SUCCESS: {
            return {
                ...state,
                loading_auth: false,
                error_auth: ''
            }
        }
        case CADASTRO_FAIL: {
            return {
                ...state,
                loading_auth: false,
                error_auth: action.payload
            }
        }
        case LOGIN_SIG: 
            return {
                ...state,
                login_sig: true,
                error_sig_auth: ''
            }
        case LOGIN_SIG_SUCCESS: 
            return {
                ...state,
                login_sig: false,
                error_sig_auth: action.payload
            }
        case LOGIN_SIG_FAIL: 
            return {
                ...state,
                login_sig: false,
                error_sig_auth: action.payload
            }
        case CADASTRO_USER:
            return { ...state, ...action.payload }
        case LIMPA_MSGS:
            return { ...state,msg_cadastroUser: '', userUpdate: undefined }
        default:
            return state
    }
};